import type { ApiMode } from '../api/mode';

export interface FixtureBannerProps {
  mode: ApiMode;
}

/**
 * fixture backendを選んでいる間ずっと出す帯。
 * 実APIの障害表示（ProblemNoticeの赤・橙）と取り違えないよう、
 * 色は情報色の青、形はページ幅いっぱいの帯にして見た目から分けている。
 * httpモードでは何も描かないので、画面側にモード判定を書かせない。
 */
export function FixtureBanner({ mode }: FixtureBannerProps) {
  if (mode !== 'fixture') return null;
  return (
    <div className="fixture-banner" role="status">
      <span className="fixture-banner-tag">FIXTURE</span>
      <span>fixtureデータを表示しています（実APIには接続していません）。</span>
    </div>
  );
}
